export const GLOBAL = 'global';
export const AUTH = 'auth';
export const FORMS = 'forms';
export const COUNTRIES = 'countries';
export const ROUTES = 'routes';
export const WORK_SCHEDULE_SERVICE = 'workScheduleService';
export const GENERAL = 'general';
export const CALENDAR = 'calendar';
export const MENU_SIDEBAR_STATE = 'menuSidebarState';
export const RECOR_MODAL = 'recordModal';

export const hourOptions = [...new Array(24)].map((_, index) => ({
  value: index,
  label: `${index} ч`,
}));

export const minuteOptions = [...new Array(12)].map((_, index) => {
  const handledIndex = index === 0 ? 0 : index * 5;
  return { value: handledIndex, label: `${handledIndex} мин` };
});
